import React from "react";
import { Card, DataTable, HighlightMatch, KeyValueList, Table, ValueOrPlaceholder, } from "@sscs/ui";
import { ExpandedRowDetails } from "../../../../ui";
import { getPropertyLabel, normalizeActionName } from "../../../utils";
import { getPrimaryPropertiesLabel } from "../utils";
import styles from "./eventRow.module.scss";
const EventRow = ({ event, actionMappings, eventNameFilter, rowIndex, focused, onClick, }) => {
    const hasProperties = event.properties.length > 0;
    return (React.createElement(DataTable.ExpandedRow, { id: `networking-value-${rowIndex}`, focused: focused, onClick: onClick, disabled: !hasProperties },
        React.createElement(DataTable.ExpandedRow.Summary, null,
            React.createElement(Table.Cell, null,
                React.createElement("div", null, normalizeActionName(event.on_event))),
            React.createElement(Table.Cell, null, event.event_name ? (React.createElement(HighlightMatch, { value: event.event_name, regex: eventNameFilter !== null && eventNameFilter !== void 0 ? eventNameFilter : "" })) : (React.createElement(ValueOrPlaceholder, { value: event.event_name }))),
            React.createElement(Table.Cell, null,
                React.createElement(React.Fragment, null,
                    React.createElement("div", null, normalizeActionName(event.do_action)),
                    React.createElement("div", { className: styles["action-parameters"] }, getPrimaryPropertiesLabel(actionMappings, event))))),
        React.createElement(DataTable.ExpandedRow.Details, null,
            React.createElement(ExpandedRowDetails, null,
                React.createElement(Card.Card, null,
                    React.createElement(Card.Title, null, "Properties"),
                    React.createElement(Card.Content, null,
                        React.createElement(KeyValueList, { list: event.properties.reduce((acc, [name, value]) => {
                                acc[getPropertyLabel(actionMappings, event.do_action, name)] = value;
                                return acc;
                            }, {}) })))))));
};
export default EventRow;
//# sourceMappingURL=EventRow.js.map